import { LockClosedIcon, LockOpenIcon } from "./lock-icons";

/** Same lock and circle highlight inside editable skill pills and read-only gap pills. */
export function RequirementPillLock({ isMust, selected = false, label, onToggle, disabled, id }: {
  isMust: boolean;
  selected?: boolean;
  label: string;
  onToggle?: () => void;
  disabled?: boolean;
  id?: string;
}) {
  const className = `shrink-0 rounded-full p-0.5 transition [&>svg]:h-3.5 [&>svg]:w-3.5 ${isMust ? "bg-ink/10 text-ink" : selected ? "text-ink" : "text-ink-muted"}`;
  const icon = isMust ? <LockClosedIcon /> : <LockOpenIcon />;
  if (!onToggle) return <span className={className} title={label} aria-label={label}>{icon}</span>;
  return (
    <button type="button" id={id} data-testid="match-skill-lock" disabled={disabled}
      aria-pressed={isMust} aria-label={label} title={label}
      className={`${className} ${disabled ? "" : `focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-ui ${isMust ? "hover:text-ink-muted" : "hover:text-ink-accent"}`}`}
      onClick={(event) => { event.stopPropagation(); onToggle(); }}>
      {icon}
    </button>
  );
}
